import { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import moment from 'moment';
import { useEffect } from 'react';

export const handlerFilter = (event, fieldName) => {
    const shouldUpdateFilters = window.localStorage.getItem(`grid_filters_${fieldName}_Fire`)

    if (!shouldUpdateFilters || shouldUpdateFilters === '1') {
        const filterinformation = event.args.filters.map(filterGroup => ({
            field: filterGroup.datafield,
            operator: filterGroup.operator,
            filters: filterGroup.filter.getfilters().map(filter => ({
                value: filter.value,
                condition: filter.condition,
                operator: filter.operator
            }))
        }));

        const actionFired = window.localStorage.getItem(`grid_filters_${fieldName}_ActionFired`)

        if (actionFired !== "1") {
            window.localStorage.setItem(`grid_filters_${fieldName}`, JSON.stringify(filterinformation))
        }
        window.localStorage.setItem(`grid_filters_${fieldName}_Fire`, 1)
    }
};

export const handlerPagination = (event, fieldName) => {
    const shouldUpdateFilters = window.localStorage.getItem(`grid_pagination_${fieldName}_Fire`)

    if (!shouldUpdateFilters || shouldUpdateFilters === '1') {
        //Obtener la información de la paginación
        const currentPage = event.args.pagenum;

        const actionFired = window.localStorage.getItem(`grid_pagination_${fieldName}_ActionFired`)

        if (actionFired !== "1") {
            window.localStorage.setItem(`grid_pagination_${fieldName}`, JSON.stringify(currentPage))
        }
        window.localStorage.setItem(`grid_pagination_${fieldName}_Fire`, 1)
    }
};

export const applyPagination = (gridRef, fieldName, useLocalStorage) => {
    if ((gridRef && gridRef.current) || useLocalStorage === true) {
        const gridInstance = gridRef.current;

        window.localStorage.setItem(`grid_pagination_${fieldName}_Fire`, 0)

        const currentPage = JSON.parse(window.localStorage.getItem(`grid_pagination_${fieldName}`));
        
        if (currentPage) {
            try {
                gridInstance.gotopage(currentPage);
            } catch (error) {
                
            }
            
            window.localStorage.setItem(`grid_pagination_${fieldName}_Fire`, 1)
        }
    }
};

export const applyFilters = (gridRef, fieldName, useLocalStorage) => {
    if ((gridRef && gridRef.current && gridRef.current.getfilterinformation().length !== 0) || useLocalStorage === true) {
        const gridInstance = gridRef.current;

        window.localStorage.setItem(`grid_filters_${fieldName}_Fire`, 0)

        const savedFilters = JSON.parse(window.localStorage.getItem(`grid_filters_${fieldName}`));
        
        if (savedFilters) {
            try {
                gridInstance.clearfilters();
                savedFilters.forEach(filterGroup => {
                    filterGroup.filters.forEach(_filter => {
                        let filtergroup = new jqx.filter();

                        let filter_or_operator = _filter.operator;
                        let filtervalue = _filter.value;
                        let filtercondition = _filter.condition;
                        let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
                        filtergroup.addfilter(filter_or_operator, filter);
                        gridInstance.addfilter(filterGroup.field, filtergroup);
                    });
                });
                gridInstance.applyfilters();
            } catch (error) {
                
            }
            
            window.localStorage.setItem(`grid_filters_${fieldName}_Fire`, 1)
        }
    }
};

export const useFilterActionComponentData = (gridRef, messageConfig, fieldName) => {    
    useEffect(() => {
        const actionFilterFired = window.localStorage.getItem(`grid_filters_${fieldName}_ActionFired`);
        const actionPaginationFired = window.localStorage.getItem(`grid_pagination_${fieldName}_ActionFired`);
        if (actionFilterFired === "1") {
            applyFilters(gridRef, fieldName, true);
            window.localStorage.setItem(`grid_filters_${fieldName}_ActionFired`, 0);
        }
        if (actionPaginationFired === "1") {
            applyPagination(gridRef, fieldName, true);
            window.localStorage.setItem(`grid_pagination_${fieldName}_ActionFired`, 0);
        }
    }, [messageConfig, fieldName]);
}

export const setterActionFired = (fieldName, value) => {    
    window.localStorage.setItem(`grid_filters_${fieldName}_ActionFired`, value);
    window.localStorage.setItem(`grid_pagination_${fieldName}_ActionFired`, value);
}

export const removeGridLocalStorageFilters = (fieldName) => {    
    window.localStorage.removeItem(`grid_filters_${fieldName}`);
    window.localStorage.removeItem(`grid_filters_${fieldName}_ActionFired`);
    window.localStorage.removeItem(`grid_filters_${fieldName}_Fire`);
}

export const cellRenderClassStyle = (row, columnfield, value, columnType, list) => {
    let className = "";
    switch (columnType) {
        case "textbox":
            if (value === '') {
                className = 'jqx-custom-validation-red';
            }
            else {
                className = '';
            }
            break;
        case "numberinput":
            if (value < 0 || value === '') {
                className = 'jqx-custom-validation-red';
            }
            else {
                className = '';
            }
            break;
        case "datetimeinput":
            if (value === '') {
                className = 'jqx-custom-validation-red';
            }
            else {
                className = '';
            }
            break;
        case "dropdownlist":
            if (value === null || value === '' || value === 0) {
                className = 'jqx-custom-validation-red';
            }
            else {
                className = '';
            }
            break
        default:
            break;
    }

    const aux_row = typeof row === 'number' && !isNaN(row) ? list[row] : row.bounddata

    if (columnfield === "startDate" || columnfield === "endDate") {
        const startDate = moment(aux_row["startDate"]);
        const endDate = moment(aux_row["endDate"]);
        const dateDiff = startDate.diff(endDate);
    
        if (className === "") {
            if (dateDiff > 0) {   
                className = 'jqx-custom-validation-red';
            }
            else {
                className = ''; 
            }
        }
    }

    return className;
};

export const executeScrollMovementToFixLockRowOnEditCell = (gridRef) => {
    try {
        const gridContainer = gridRef.current;
        if (gridContainer) {

            const position = gridRef.current.scrollposition();
            const minimalScrollIncrement = 1;

            gridRef.current.scrolloffset(position.top, position.left + minimalScrollIncrement);
            gridRef.current.scrolloffset(position.top, position.left - minimalScrollIncrement);
        }
    } catch (error) {

    }
}

